import React, { useEffect, useMemo, useState } from "react";
import clsx from "clsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBarsSort,
  faChevronDown,
  faChevronUp,
  faXmark,
  faSquareSlidersVertical,
} from "@fortawesome/pro-regular-svg-icons";
import {
  connectRefinementList,
  connectSortBy,
  connectToggleRefinement,
  connectStateResults,
  connectRange
} from "react-instantsearch-core";

import * as classes from "./Refinement.module.css";
import { useMeasure, useMedia, useScroll, useStartTyping } from "react-use";
import { createRef } from "react";
import { useStickyContext } from "~src/utils/Sticky";
import { usePopper } from "react-popper"; 
import { v4 } from "uuid";
import { indexMap } from "./ProductListingPage"; 
import useForkRef from "@rooks/use-fork-ref";
import { usePLPContext } from "../ProductListingPage/ProductListingPage";
import { set, sortBy } from "lodash";
import { clear } from "console";

export const Refinement = connectStateResults(
  ({ searchResults, searchState, bubbleFilters, tabName, setSearchState, handle, highestPriceProduct, lowestPriceProduct }) => {
    const { b2b, refinementToggle, setRefinementToggle } = usePLPContext();

    const handleClearAll = () => {
      setFilterTray(false);
      setSearchState((prev) => ({
        ...prev,
        page: 1,
        refinementList: undefined,
        sortBy : "production_shopify_products",
        toggle: b2b ? {[b2b] : 'true'} : undefined,
        range: undefined
      }));
      setActiveFilters([]);
      setClearRange(true);
      setRefinementToggle({boolean: ''});
    };

    const isDesktop = useMedia("(min-width: 768px)");
    const { stickyElementRef, isStuck } = useStickyContext();
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => {
      setOpen((prev) => !prev);
    };
    const [filterTray, setFilterTray] = React.useState(false);
    const handleFilterTray = () => {
      setFilterTray((prev) => !prev);
    };

    const [SearchStateTrigger, setSearchStateTrigger] = React.useState('')
    const [userSelect, setUserSelect] = React.useState('')

    const [scrolled, setScrolled] = React.useState(false);
    const handleScroll = (event) => {
      setScrolled(event.target.scrollLeft ? true : false);
    };

    const [currentlyRefined, setCurrentlyRefined] = React.useState();
    const [ClearRange, setClearRange] = React.useState(false);

    const defaultSortBy = () => {
      setSearchState((prev) => ({
        ...prev,
        sortBy:'production_shopify_products',
      }))
    }


    React.useEffect(() => {
      if (filterTray) {
        document.body.classList.add("overflow-hidden")
        document.querySelector('#shopify-section-header').classList.add('outOfFocus')
        if(isStuck){
          document.body.classList.add('shopify-section-header-hidden')
        }
        return () => {
          document.body.classList.remove("overflow-hidden")
          document.querySelector('#shopify-section-header').classList.remove('outOfFocus')
        };
      }
    }, [filterTray]);

    const [ActiveSearchFilters, setActiveFilters] = React.useState([]);

    let filterLength = []
    let filters = [];

    React.useEffect(() => {
      let clearFilters = true;
      let activeFilters = searchState?.refinementList;
      for (const filter in activeFilters) {
        if (activeFilters[filter] != "") {
          clearFilters = false;
          filterLength.push(activeFilters[filter].length)
          activeFilters[filter].map((item) => {
            filters.push(item);
            setActiveFilters(filters);
          });
        }
      }

      if(clearFilters){
        if(SearchStateTrigger != 'UsersortBy' && searchState?.sortBy === 'production_shopify_products_newest' && currentlyRefined === undefined && userSelect != 'newest'){
          defaultSortBy();
        }
        setActiveFilters([]);
      }
    }, [searchState]);
    
    const [maxScroll, setMaxScroll] = React.useState(false);
    const [minScroll, setMinScroll] = React.useState(false);


    const watchScroll = function(e){
      const scrollPosition = Math.round(e.target.scrollTop)
      const maxElementScroll = e.target.scrollHeight - e.target.clientHeight
      if(scrollPosition == maxElementScroll || scrollPosition >= maxElementScroll - 40  ){
        setMaxScroll(true)
      } else {
        setMaxScroll(false)
      }

      if(scrollPosition > 0){
        setMinScroll(true)
      } else {
        setMinScroll(false)
      }
    }
  
    // if (!searchResults) return null;

    // const facets = searchResults.renderingContent.facetOrdering?.facets.order || [];
    // const facets = searchResults?.renderingContent?.facetOrdering?.facets.order
    //   ? searchResults.renderingContent.facetOrdering?.facets.order
    //   : [];
    // const facets = [
    //   "optionAvailability.Size",
    //   "facets.Colour",
    //   "facets.Support",

    //   "facets.Browse_all",
    //   "facets.Gender",
    //   "product_type",
    //   "available",
    //   "facets.Diet",
    //   "facets.Length",
    //   "facets.Material",
    //   "facets.Tops",
    //   "facets.Tees_tanks",
    //   "facets.Bras",
    //   "facets.Bralettes",
    //   "facets.Leggings",
    //   "facets.Shorts",
    //   "facets.Mens_shorts",
    //   "facets.Jumpers",
    //   "facets.Tracksuit_sets",
    //   "facets.Fit",
    //   "facets.Weight",
    //   "facets.Activity",
    //   "facets.Winter",
    //   "facets.Accessories",

    //   "facets.Maternity",
    //   "facets.Scrunch",
    //   "facets.Non-scrunch",
    //   "facets.Flavour",
    //   "facets.Caffeine Free",
    //   "facets.Pre_workout",
    //   "facets.Bars_snacks",
    //   "facets.Custard",
    //   "facets.Protein",
    //   "facets.Protein_snacks",
    //   "facets.Rtd",
    //   "facets.Daily_greens",
    //   "facets.Protein_water",
    //   "facets.Protein_powder",
    //   "facets.Hydration",
    //   "facets.Vegan_friendly",
    //   "facets.Gluten_free",
    //   "discounted",

    //   "sale_percentage"
    // ];
    const facets = window.facets_order;

    // const supportHasBraToggles = facets.includes('facets.Bras') || facets.includes('facets.Bralettes')
    const supportHasBraToggles = searchResults?.renderingContent?.facetOrdering?.facets.order.includes('facets.Bras') || searchResults?.renderingContent?.facetOrdering?.facets.order.includes('facets.Bralettes')
    
    const refinementList = searchState.refinementList;

    const hasNoFilters = facets.every(
      (facet) => window.facets[facet]?.type == "boolean"
    );

    const filtersActive = ActiveSearchFilters.length != 0

    const handleLink = (url) => () => {
      window.location.href = `${url}`;
    }

    return (
      <>
        <div ref={stickyElementRef} className="component__refinement_wrapper">
          <div className="sortby-container">
            {isDesktop && (
              <div className="sortby-wrapper">
                <div className="sortby">
                  <span>Sort By</span>
                  {/* <RangeSlider defaultRefinement={{
                    min:0 
                  }} attribute={"price"}/> */}
                  <SortOptionsDropdown
                    searchState={searchState}
                    SearchStateTrigger={SearchStateTrigger}
                    setSearchStateTrigger={setSearchStateTrigger}
                    setUserSelect={setUserSelect}
                    items={Object.entries(indexMap).map(([key, value]) => ({
                      value,
                      label: window.collectionStrings.indices[key],
                    }))}
                  />
                  <div
                    className={`sort-wrapper ${open ? "open" : ""}`}
                    onMouseLeave={handleOpen}
                  >
                    <SortOptions
                      searchState={searchState}
                      SearchStateTrigger={SearchStateTrigger}
                      setSearchStateTrigger={setSearchStateTrigger}
                      setUserSelect={setUserSelect}
                      items={Object.entries(indexMap).map(([key, value]) => ({
                        value,
                        label: window.collectionStrings.indices[key],
                      }))}
                    />
                  </div>

                </div>
              </div>
            )}
          </div>
        </div>
        <div className={clsx(`filter-wrapper`, { stuck: isStuck })}>
          <div className={`filters`}>
            {!isDesktop && (
              <button className={clsx(`filter`, filtersActive ? ' active' : '' )} onClick={handleFilterTray}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="10"
                  viewBox="0 0 12 10"
                  fill="none"
                >
                  <path
                    d="M2.23389 9.3052L2.23389 6.0105"
                    stroke="#18181B"
                    stroke-width="1.2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M2.23389 4.12795L2.23389 0.833252"
                    stroke="#18181B"
                    stroke-width="1.2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M5.99951 9.30538L5.99951 5.06934"
                    stroke="#18181B"
                    stroke-width="1.2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M5.99951 3.18661L5.99951 0.833252"
                    stroke="#18181B"
                    stroke-width="1.2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9.76465 9.30575V6.95239"
                    stroke="#18181B"
                    stroke-width="1.2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9.76465 5.06929L9.76465 0.833252"
                    stroke="#18181B"
                    stroke-width="1.2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M0.822266 6.0105L3.64629 6.0105"
                    stroke="#18181B"
                    stroke-width="1.2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M4.58789 3.18677L7.41192 3.18677"
                    stroke="#18181B"
                    stroke-width="1.2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M8.35254 6.95239L11.1766 6.95239"
                    stroke="#18181B"
                    stroke-width="1.2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <span className={scrolled ? "scrolled" : ""}>{filtersActive ? "Filters Active" : "Filter"}</span>
              </button> 
            )}
            <div className={`booleans-wrapper`} onScroll={handleScroll}>
              {facets?.map((facet) => {
                let facetType = window.facets[facet]?.type;
                if (facetType == "boolean") {
                  return (
                    <ToggleRefinement
                      key={facet}
                      attribute={facet}
                      label={window.collectionStrings.facets[facet]}
                      value={true}
                      searchState={searchState}
                      setSearchState={setSearchState}
                      setCurrentlyRefined={setCurrentlyRefined}
                      currentlyRefined={currentlyRefined}
                      searchResults={searchResults}
                    />
                  );
                }
              })}
            </div>
          </div>
        </div>

        <div
          className={clsx(classes.root + " component__refinement", {
            [classes.stuck]: isStuck,
            ["mobile"]: !isDesktop,
            ["open"]: filterTray,
            ["hidden"]: isDesktop && hasNoFilters,
          })}
        >
          <div
            className={clsx(classes.backdrop, {
              [classes.open]: filterTray,
            })}
            onClick={handleFilterTray}
          />
          <div
            className={clsx("refinement-list-wrapper component__refinement", {
              ["open"]: filterTray,
            })}
          >
            <div className={clsx("clear_all" + `${minScroll ? " shadowEnabled" : "" }`, {})}>
                {!isDesktop && (
                  <div className={clsx(
                    "clear_all_wrapper" +
                      `${isDesktop ? " disabled" : " enabled"}`,
                    {}
                  )}>
                    <button
                      onClick={handleFilterTray}
                      type="button"
                      aria-label="Close refinement menu"
                      className={clsx(
                        "fab close",
                        classes.refinementMenuCloseButton
                      )}
                    >
                      <FontAwesomeIcon width={16} height={16} icon={faXmark} />
                    </button>
                  </div>
                )}
                {isDesktop ? <div>Filters</div> : <div>Sort & Filter</div>}
                <div>
                  <button
                    onClick={handleClearAll}
                    className={clsx(
                      "clear_all_button" +
                        `${(ActiveSearchFilters.length != 0 || searchState?.range || searchState?.sortBy != 'production_shopify_products') ? "" : " disabled"}`,
                      {}
                    )}
                  >
                    Clear All
                  </button>
                </div>
              </div>
            <div className={clsx(classes.innerTray )} onScroll={watchScroll}>
              <div className={classes.list + " refinement-list"}>
                {!isDesktop && (
                  <Menu 
                    count={0} 
                    buttonLabel={`Sort By`} 
                    menuLabel={`Sort By`} 
                  >
                    <SortOptions
                      searchState={searchState}
                      SearchStateTrigger={SearchStateTrigger}
                      setSearchStateTrigger={setSearchStateTrigger}
                      setUserSelect={setUserSelect}
                      items={Object.entries(indexMap).map(([key, value]) => ({
                        value,
                        label: window.collectionStrings.indices[key],
                      }))}
                    />
                  </Menu>
                )}

                {window.dynamicFilterCollections && (
                  <>
                    {window?.dynamicFilterCollections?.map((collection, key) => {
                      return (
                        <Menu
                          key={key}
                          count={collection.data.length}
                          buttonLabel={collection.name}
                          menuLabel={collection.name}
                        >
                          {collection.data.map((item, key) => (
                            <label
                              key={key} 
                            >
                              <span 
                                onClick={handleLink(item.url)}
                                style={{cursor: 'pointer'}}
                              >
                                {item.title}
                              </span>
                            </label>
                          ))}
                        </Menu>
                      )
                    })}
                  </>
                )}

                {facets?.map((facet) => {
                  let facetType = window.facets[facet]?.type;
                  let facetMenuLabel = window.collectionStrings.facets[facet];
                  const facetNoDisplay = facetType != "boolean" && facetMenuLabel != undefined;

                  /* If 'Support' facet is available and Bras / Bralettes boolean toggle are available,
                   * hide Support unless Bra / Bralettes is toggled on.
                   */
                  // let displaySupport = searchState?.toggle && (searchState?.toggle['facets.Bralettes'] || searchState?.toggle['facets.Bras']) && facet == 'facets.Support' || supportHasBraToggles && facet != 'facets.Support' || !supportHasBraToggles

                  // if (facetNoDisplay && displaySupport) {
                  if (facetNoDisplay) {
                    return (
                      <Menu
                        key={facet}
                        attribute={facet}
                        count={
                          refinementList ? refinementList[facet]?.length : 0
                        }
                        buttonLabel={window.collectionStrings.facets[facet]}
                        menuLabel={facetMenuLabel}
                        searchResults={searchResults}
                      >
                        {facet == "facets.Price_slider" &&(
                          <RangeSlider highestPriceProduct={highestPriceProduct} lowestPriceProduct={lowestPriceProduct} defaultRefinement={{
                            min:lowestPriceProduct,
                            max:highestPriceProduct
                          }} attribute={"price"} ClearRange={ClearRange} setClearRange={setClearRange} searchState={searchState} setSearchState={setSearchState} />
                        )}
                        <MenuRefinement
                          attribute={facet}
                          searchState={searchState}
                          setSearchState={setSearchState}
                          handle={handle}
                          limit={15}
                          SearchStateTrigger={SearchStateTrigger}
                          setSearchStateTrigger={setSearchStateTrigger}
                        />
                      </Menu>
                    );
                  }
                })}
              </div>
            </div>
            {!isDesktop && (
              <div className={clsx(
                classes.applyFiltersWrapper + " " + `${maxScroll ? classes.shadowDisabled : "" }`)}
              >
                <button
                  onClick={handleFilterTray}
                  className={clsx(
                    classes.applyFiltersButton +
                      ` ${(ActiveSearchFilters.length != 0 || searchState?.range) ? "" : classes.disabled}` +` button button--contained button--full-width`)}
                >
                  Apply Filters {(ActiveSearchFilters.length != 0 || searchState?.range) ? "(" + searchResults?.nbHits + ")" : ""}
                </button>
              </div>
            )}
          </div>
        </div>
      </>
    );
  }
);

const RangeSlider = connectRange(({ refine, defaultRefinement, searchState, setSearchState, attribute, start, range, min, max, highestPriceProduct, lowestPriceProduct, ClearRange, setClearRange }) => {
  const [maxRange, setMaxRange] = React.useState(highestPriceProduct)

  const [minSliderRange, setMinSliderRange] = React.useState(lowestPriceProduct)

  const [maxSliderRange, setMaxSliderRange] = React.useState(highestPriceProduct)

  function adjustRange(){
    const lowerSlider = document.querySelector('#fromSlider');
    const upperSlider = document.querySelector('#toSlider');

    let lowerVal = parseInt(lowerSlider.value);
    let upperVal = parseInt(upperSlider.value);

    setMinSliderRange(lowerSlider.value)
    setMaxSliderRange(upperSlider.value)

    if (upperVal < lowerVal + 8) {
      lowerSlider.value = upperVal - 8;
      if (lowerVal == lowerSlider.min) {
        upperSlider.value = 8;
      }
    }
      
    if (lowerVal > upperVal - 8) {
      upperSlider.value = lowerVal + 8;
      if (upperVal == upperSlider.max) {
        lowerSlider.value = parseInt(upperSlider.max) - 8;
      }
    }


    //  Adjust width of bar in center

    let leftHandSide = (((document.querySelector('#fromSlider').value - document.querySelector('#fromSlider').min) / (document.querySelector('#fromSlider').max - document.querySelector('#fromSlider').min)) * ((document.querySelector('#fromSlider').clientWidth - 16) + 16))

    let rightHandSide = (document.querySelector('#toSlider').clientWidth - ((document.querySelector('#toSlider').value - document.querySelector('#toSlider').min) / (document.querySelector('#toSlider').max - document.querySelector('#toSlider').min)) * ((document.querySelector('#toSlider').clientWidth - 16) + 16))

    let widthOfSlider = document.querySelector('#toSlider').clientWidth - leftHandSide - rightHandSide;

    document.querySelector('.progressFollower').style.left = leftHandSide + 'px'
    
    document.querySelector('.progressFollower').style.width = widthOfSlider + 'px'

  }

  function handleRangeChange(){
    setSearchState((prev) => ({
      ...prev,
      range: {
        "price": {
            "min": minSliderRange,
            "max": maxSliderRange
        }
      }
    }));
  }

  function clearRange(){
    const lowerSlider = document.querySelector('#fromSlider');
    const upperSlider = document.querySelector('#toSlider');
    const progressFollower = document.querySelector('.progressFollower');

    setMinSliderRange(lowestPriceProduct)
    setMaxSliderRange(highestPriceProduct)
    
    progressFollower.style.left = '0px'
    progressFollower.style.right = document.querySelector('#toSlider').clientWidth + 'px'
    progressFollower.style.width = document.querySelector('#toSlider').clientWidth + 'px'
    lowerSlider.value = parseInt(lowerSlider.min)
    upperSlider.value = parseInt(upperSlider.max)
  }

  React.useEffect(() => {
    if(ClearRange == true){
      clearRange();
      setClearRange(false)
    }
  }, [ClearRange])  

  return (
    <>
    <div className="range_container"> 
        <span className="progressBackground"></span>
      <div className="sliders_control">
        <span className="progressFollower"></span>
        <input type="range" onInput={adjustRange} onTouchEnd={handleRangeChange} onMouseUp={handleRangeChange} id="fromSlider" min={lowestPriceProduct} max={highestPriceProduct} defaultValue={minSliderRange}></input>
        <input type="range" onInput={adjustRange} onTouchEnd={handleRangeChange} onMouseUp={handleRangeChange} id="toSlider" min={lowestPriceProduct} max={highestPriceProduct} defaultValue={maxSliderRange}></input>
      </div>

      <div className="slider_labels">
        <label aria-label="min price range">${minSliderRange}</label>
        <label aria-label="max price range">${maxSliderRange}</label>
      </div>

    </div>
    </>
  )
})
 
const ToggleRefinement = connectToggleRefinement(
  ({ searchResults, currentRefinement, label, count, value, setSearchState, attribute, currentlyRefined, setCurrentlyRefined, searchState }) => {
    const { b2b, refinementToggle, setRefinementToggle } = usePLPContext();
    return (
      <button
        aria-pressed={currentRefinement}
        onClick={() => {
          setRefinementToggle((prev) => ({
            ...prev,
            boolean: refinementToggle?.boolean[attribute] == true ? '' : {[attribute]: true},
          }));
          setTimeout(() => {
            setCurrentlyRefined(currentRefinement ? undefined : attribute)
            setSearchState((prev) => ({
              ...prev,
              // ...(searchState.sortBy === 'production_shopify_products' && window?.collectionType != "supplements" ? {sortBy:'production_shopify_products_newest'} : {}),
              page: 1,
              ...(currentRefinement ? 
                  b2b ? {toggle: {[b2b]: 'true'}} : {toggle: {}} 
                : 
                  b2b ? { toggle: {[attribute]: !currentRefinement, [b2b]: 'true'} } : { toggle: {[attribute]: !currentRefinement} }
              )
            }));
          }, 100)
        }}
        className={`boolean-refinement refinementButton-boolean 
          ${(searchResults?.renderingContent?.facetOrdering?.facets.order.includes(attribute)) ? '' : 'hidden'} 
          ${label} 
          ${clsx("", { [classes.open + " open"]: refinementToggle?.boolean[attribute] != undefined ? true : false})}`
          
        }
      >
        {label}
      </button>
    );
  }
);

const ToggleRefinementImage = connectToggleRefinement(
  ({ refine, currentRefinement, label, tabName, count, value }) => {
    return (
      <button
        aria-pressed={currentRefinement ? "true" : "false"}
        onClick={() => {
          refine(!currentRefinement);
        }}
        className={
          "boolean-refinement " +
          "refinementButton-boolean" +
          "-withImage" +
          " " +
          label +
          " " +
          clsx(classes.refinementButton, {
            [classes.open]: currentRefinement,
          })
        } 
      >
        <div className="refinement-image-container">
          <img className={"refinement-image " + tabName + " " + label}></img>
        </div>
        <p>{label}</p>
      </button>
    );
  }
);

const Menu = ({
  buttonLabel = null,
  buttonIcon = null,
  menuLabel = null,
  children,
  count = 0,
  attribute = null,
  searchResults = null,
}: {
  buttonLabel: any;
  menuLabel: any;
  buttonIcon?: any;
  children: React.ReactNode;
  count?: number;
  attribute?: any;
  searchResults?: any;
  filter: any;
}) => {
  const isWide = useMedia("(min-width: 640px)");
  const buttonRef = React.useRef<HTMLButtonElement>(null);
  const menuRef = React.useRef<HTMLDivElement>(null);
  const listRef = React.useRef<HTMLDivElement>(null); 
  const [open, setOpen] = React.useState(isWide || !isWide && (menuLabel == 'Sort By' || menuLabel == 'Padding' ) ? true : false);
  const popperButtonRef = isWide ? buttonRef.current : null;
  const { styles, attributes } = usePopper(popperButtonRef, menuRef.current, {
    modifiers: [
      {
        name: "offset",
        options: {
          offset: [0, 8],
        },
      },
    ],
  });

  const { y: listY } = useScroll(listRef);
  const [listMeasureRef, { height: listHeight }] = useMeasure();
  const listScrollHeight = listRef.current ? listRef.current.scrollHeight : 0;

  const listCombinedRef = useForkRef(listRef, listMeasureRef);

  const headerId = React.useMemo(() => `MenuHeader-${v4()}`, []);

  // React.useEffect(() => {
  //   if (open) {
  //     window.trapFocus(menuRef.current);
  //     document.body.classList.add("overflow-hidden--small-down");
  //     return () => {
  //       window.removeTrapFocus(buttonRef.current);
  //       document.body.classList.remove("overflow-hidden--small-down");
  //     };
  //   }
  // }, [open]);

  // React.useEffect(() => {
  //   if (open && !isWide) {
  //     if(window?.GorgiasChat && window?.GorgiasChat?.hideOnMobile(true)){
  //       return () => {
  //         window.GorgiasChat && window.GorgiasChat.hideOnMobile(false);
  //       };
  //     }
  //   }
  // }, [open, isWide]); 

  const handleClick = () => {
    setOpen((prev) => !prev);
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    switch (event.key) {
      case "Escape":
        setOpen(false);
        break;
      default:
        break;
    }
  };

  const showMenu = searchResults?._rawResults[0].facets[attribute] != undefined

  return (
    <div className={`refinementButton-sort ${showMenu && (searchResults?.renderingContent?.facetOrdering?.facets.order.includes(attribute) || attribute == undefined) ? '' : 'hidden'}`} data-filter={menuLabel}>

      <div
        className={"refinementButton-sort-wrapper" + ` ${open ? "open" : ""}`}
        tabIndex={-1}
        aria-labelledby={headerId}
        ref={menuRef}
        onKeyDown={handleKeyDown}
        {...(isWide && attributes.popper)}
      >
        <div
          id={headerId}
          className={
            classes.refinementMenuHeader +
            ` refinementMenuHeader ${open ? "open" : ""}`
          }
          // onClick={handleClick}
          onMouseUp={handleClick}
        >
          {menuLabel}
          <FontAwesomeIcon width={16} height={16} icon={faChevronDown} />
        </div>
        <div
          ref={listCombinedRef}
          className={clsx(
            classes.refinementMenuList +
              ` refinementMenu ${open ? "open" : ""}`,
            {}
          )}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

const updateVariantTitle = (title) => {
  const percentages = [
    "0.1",
    "0.2",
    "0.3",
    "0.4",
    "0.5",
    "0.6",
    "0.7",
    "0.8",
    "0.9",
  ];

  switch (title) {
    case "XXS":
      title = "2XS";
      break;
    case "XXL":
      title = "2XL";
      break;
    case "XXXL":
      title = "3XL";
      break;
    case "XXXXL":
      title = "4XL";
      break;
    default:
      break;
  }
  if (percentages.includes(title)) {
    title = 100 - (parseFloat(title) * 100) + "%";
  }
  return title;
};

const hiddenSizes = ["One Size", "ONE","one", "US 6", "US 7.5", "US 9", "US 12", "S/M/L", "1", "2", "3", "4", "1-2", "Default Title"];
const approvedSizes = ["XXS","XS","S","M","L","XL","XXL","XXXL","XXXXL"];
 
const MenuRefinement = connectRefinementList(
  ({
    items,
    refine,
    currentRefinement,
    attribute,
    searchState = undefined,
    setSearchState = undefined,
    handle,
    setSearchStateTrigger,
    SearchStateTrigger
  }) => {
    const { refinementToggle, setRefinementToggle } = usePLPContext();

    const refinements = refinementToggle[attribute] != undefined ? refinementToggle[attribute] : [];

    const handleCheckboxClick = (value) => {
      let newValues = [...refinements];
      if(newValues.includes(value)){
        newValues = newValues.filter((item) => item != value);
      }else{
        newValues.push(value);
      }
      setRefinementToggle((prev) => ({
        ...prev,
        [attribute]: newValues,
      }));
    };

    return items
      .filter((item) => attribute == 'optionAvailability.Size' ? 
        approvedSizes.includes(item.label)
        : 
        !hiddenSizes.includes(item.label)
      )
      .map(({ value, label, count, isRefined }, index) => {
        const id = `Checkbox-${window.Shopify.handleize(attribute)}-${window.Shopify.handleize(label)}-${handle}`;

        const backgroundImagePrint = label == 'Print' ? { backgroundImage: "url(https://cdn.shopify.com/s/files/1/0017/6075/5779/files/421569129_644452027736798_5860997571310260696_n_430x.png"} : {}

        return (
          <label
            id={id}
            className={classes.option + " option"}
            data-option={updateVariantTitle(label)} 
            data-type={attribute}
            key={index}
          >
            <input
              id={id}
              type="checkbox"
              value={value}
              name={attribute}
              onClick={() => {
                handleCheckboxClick(label);
              }}
              onChange={() => {
                // refine(value);
                // setSearchStateTrigger('Userrefineclick')
                setTimeout(() => {
                  refine(value);
                  setSearchStateTrigger('Userrefineclick')
                }, 100)
              }}
              checked={refinements?.includes(label)}
            />
            {attribute == "facets.Colour" && (
              <div
                className={`color-bubble ${updateVariantTitle(label)}`}
                style={backgroundImagePrint}
              >
              </div>
            )}
            <span>{updateVariantTitle(label)}</span>
          </label>
        );
      })
    }
);

const SortOptionsDropdown = connectSortBy(({ items, min, max, refine, searchState, setSearchStateTrigger, SearchStateTrigger, setUserSelect}) => {
  return (
    <select
      onChange={(e) => {
        setSearchStateTrigger('UsersortBy')
        {e.target.value === 'production_shopify_products_newest' && window?.collectionType != "supplements" ? setUserSelect('newest') : setUserSelect(e.target.value) }
        refine(e.target.value);
      }}
    >
      {items.map(({ label, value, isRefined }) => {
        return <option selected={searchState?.sortBy == 'production_shopify_products_newest' && value == 'production_shopify_products_newest' || searchState?.sortBy == 'production_shopify_products' && value == 'production_shopify_products' } value={value}>{label}</option>;
      })}
    </select>
  );
});

const SortOptions = connectSortBy(({ items, refine, searchState, setSearchStateTrigger, SearchStateTrigger, setUserSelect}) =>
  items.map(({ label, value, isRefined }) => {
    const id = `Radio-${window.Shopify.handleize(value)}`;
    return (
      <label
        className={classes.option + " option " + (isRefined ? " checked" : "")}
        data-type={"Sort By"}
        key={value}
      >
        {isRefined && (
          <svg
            className="check"
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
          >
            <path
              d="M11.7482 1.75152C12.083 2.08634 12.083 2.62741 11.7482 2.96223L4.89107 9.81937C4.55625 10.1542 4.01518 10.1542 3.68036 9.81937L0.251036 6.3908C-0.0836786 6.05598 -0.0836786 5.51491 0.251036 5.18009C0.585804 4.84527 1.12848 4.84527 1.4633 5.18009L4.26161 8.00062L10.5375 1.75152C10.8723 1.41616 11.4134 1.41616 11.7482 1.75152Z"
              fill="white"
            />
          </svg>
        )}
        <input
          id={id}
          className="radio"
          checked={isRefined}
          type="radio"
          name="sortBy"
          value={value}
          onChange={() => {
            setSearchStateTrigger('UsersortBy')
            {value === 'production_shopify_products_newest' && window?.collectionType != "supplements" ? setUserSelect('newest') : setUserSelect(value) }
            refine(value);
          }}
        />
          <span>{label}</span>
        <span className="bubble">
          <span className="inner-bubble"></span>
        </span>
      </label>
    );
  })
);

/*
const Accordion: React.FC<{ label: React.ReactNode }> = ({
  label,
  children,
}) => {
  const rootRef = React.useRef<HTMLDivElement>(null);
  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    setOpen((prev) => !prev);
  };

  return (
    <div
      ref={rootRef}
      className={clsx(classes.accordion, {
        [classes.open]: open,
      })} 
    >
      <button
        type="button"
        aria-expanded={open ? "true" : "false"}
        onClick={handleClick} 
        className={classes.accordionButton}
      >
        <div className={classes.accordionButtonLabel}>{label}</div>
        {open ? (
          <FontAwesomeIcon icon={faChevronUp} width={16} height={16} />
        ) : (
          <FontAwesomeIcon icon={faChevronDown} width={16} height={16} />
        )} 
      </button>
      <div className={classes.accordionPanel}>{children}</div> 
    </div>
  );
};
*/
